export enum PayPalAddressChangeResult {
  ACCEPTED,
  REJECTED,
}
